module.exports = __webpack_public_path__ + "static/media/microbit-micropython_712309a.fc86b758.hex";